import { useState } from 'react';
import { useCurrentUser } from '../../auth/CurrentUserProvider';
import { useRolesCatalogue } from '../roles/use-roles-catalogue';
import { buildUserColumns } from './build-user-columns';
import { useUsers } from './use-users';
import type { UserListItem } from './users.api';

/** UsersPage's own state: the two drawers (create, reset password) and the columns built from `useUsers`'s row actions. */
export function useUsersPage() {
  const users = useUsers();
  const rolesCatalogue = useRolesCatalogue();
  const { state: currentUser } = useCurrentUser();
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
  const [resetPasswordTarget, setResetPasswordTarget] = useState<UserListItem | undefined>(undefined);

  const roleOptions = rolesCatalogue.status === 'loaded' ? rolesCatalogue.roles : [];
  const columns = buildUserColumns({
    roleOptions,
    currentUserId: currentUser.status === 'authenticated' ? currentUser.user.id : undefined,
    list: users.list,
    onSetRoles: users.setRoles,
    onResetPassword: (user) => {
      users.resetResetPasswordError();
      setResetPasswordTarget(user);
    },
    onDeactivate: users.deactivate,
    onReactivate: users.reactivate,
  });

  return { users, roleOptions, columns, createDrawerOpen, setCreateDrawerOpen, resetPasswordTarget, setResetPasswordTarget };
}
